export const LOAD_MEDIA_SUCCESS: string = 'LOAD_MEDIA_SUCCESS';
export const LOAD_MEDIA_START: string = 'LOAD_MEDIA_START';
export const LOAD_MEDIA_FAIL: string = 'LOAD_MEDIA_FAIL';

export const SET_AUDIO_OUTPUT_SUCCESS: string = 'SET_AUDIO_OUTPUT_SUCCESS';
export const SET_AUDIO_OUTPUT_START: string = 'SET_AUDIO_OUTPUT_START';
export const SET_AUDIO_OUTPUT_FAIL: string = 'SET_AUDIO_OUTPUT_FAIL';

export const SET_MEDIA_INPUT_SUCCESS: string = 'SET_MEDIA_INPUT_SUCCESS';
export const SET_MEDIA_INPUT_START: string = 'SET_MEDIA_INPUT_START';
export const SET_MEDIA_INPUT_FAIL: string = 'SET_MEDIA_INPUT_FAIL';

export const SET_VIDEO_QUALITY_SUCCESS: string = 'SET_VIDEO_QUALITY_SUCCESS';
export const SET_VIDEO_QUALITY_START: string = 'SET_VIDEO_QUALITY_START';
export const SET_VIDEO_QUALITY_FAIL: string = 'SET_VIDEO_QUALITY_FAIL';

export const SAVE_VIDEO_SETTINGS: string = 'SAVE_VIDEO_SETTINGS';

export const AUDIO_OUTPUT: string = 'audioOutput';
export const AUDIO_INPUT: string = 'audioInput';
export const VIDEO_INPUT: string = 'videoInput';
export const ERROR: string = 'error';

export const DEFAULT_SCREEN: string = '';
export const LOADER_SCREEN: string = 'LOADER_SCREEN';
export const ERROR_SCREEN: string = 'ERROR_SCREEN';
export const SUCCESS_SCREEN: string = 'SUCCESS_SCREEN';


